export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-100 to-background-50"></div>

      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-500/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent-500/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/3"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs text-primary-500 font-medium">实时更新 · 吃瓜不停</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-3">
              911黑料网
              <span className="block text-primary-500">全网黑料吃瓜第一站</span>
            </h1>

            <p className="text-lg text-accent-500 font-heading font-semibold mb-5">
              最新 · 最全 · 最快 —— 吃瓜群众的终极聚集地
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              911黑料网整合全网最新黑料事件、明星八卦与热点爆料，提供911黑料吃瓜网、911吃瓜黑料网官方入口一站式导航。
              每日更新海量吃瓜内容，覆盖娱乐圈、网红圈、社会热点等多领域黑料，让你快速访问不迷路，吃瓜永远快人一步。
              当前热门专题聚焦近期最劲爆的圈内大瓜，持续追踪事件进展。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10">
                  <i className="ri-article-line text-accent-500 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">12,800+</div>
                  <div className="text-xs text-foreground-500">累计黑料事件</div>
                </div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden md:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10">
                  <i className="ri-user-heart-line text-primary-500 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">860万+</div>
                  <div className="text-xs text-foreground-500">月活吃瓜用户</div>
                </div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden md:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-500/10">
                  <i className="ri-timer-flash-line text-secondary-500 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">24h</div>
                  <div className="text-xs text-foreground-500">全天候滚动更新</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                onClick={(e) => handleScrollTo(e, '#updates')}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-flashlight-line text-lg"></i>
                立即吃瓜
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScrollTo(e, '#ranking')}
                className="inline-flex items-center gap-2 px-7 py-3 bg-background-200 hover:bg-background-300 text-foreground-700 font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm border border-background-300/60"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative">
              <div className="absolute inset-0 bg-primary-500/10 rounded-2xl blur-xl"></div>
              <div className="relative bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden p-5">
                <img
                  src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20detective%20style%20collage%20with%20newspaper%20clippings%2C%20magnifying%20glass%2C%20redacted%20documents%2C%20dramatic%20lighting%2C%20breaking%20news%20aesthetic%2C%20film%20noir%20atmosphere%2C%20warm%20red%20and%20gold%20accents%20on%20dark%20background%2C%20editorial%20design&width=900&height=1100&seq=hero-main-2026&orientation=portrait"
                  alt="911黑料网 - 全网黑料吃瓜第一站主视觉"
                  className="w-full h-auto rounded-lg"
                />
                <div className="absolute bottom-4 left-4 right-4 bg-background-100/90 backdrop-blur-sm rounded-lg p-3 border border-background-200/40">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="w-7 h-7 flex items-center justify-center rounded-md bg-primary-500">
                      <i className="ri-fire-fill text-background-50 text-xs"></i>
                    </span>
                    <span className="text-xs text-foreground-600 font-medium">今日劲爆头条</span>
                  </div>
                  <p className="text-sm text-foreground-800 font-semibold line-clamp-1">
                    顶流艺人深夜密会曝光，圈内人士独家实锤爆料细节流出
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}